import React from 'react'
import { Box,Typography,TextField,Button,FormLabel,Link, InputAdornment,MenuItem,Select,IconButton,RadioGroup,Radio,FormControlLabel,FormControl} from "@mui/material";


const style = {
    position: 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

const textStyle ={
  fontSize:{xs:20,sm:24, md:30}
}


const Info = () => {
  return (
    <Box sx={{
        // ...style,
        position:'absolute',
        left:'50%',
        // right:'50%',
        top:{xs:'50%',md:'40%'},
        // bottom:'50%',
        transform: 'translate(-50%, -50%)',
        color:'primary.light',
        width:{xs:'260px',sm:'500px',md:'700px'},
        
        // height:'800px',
        backgroundColor: '#010101',
        border:2,
        borderColor: 'primary.main',
        p:{xs:2,sm:4},

    }}>
        <Typography align="center" variant='h5' sx={{pb:{xs:2,md:4}, color: 'primary.main',fontSize:{xs:26,sm:32,md:44}}}>Guidedly</Typography>
        <Typography sx={textStyle}>Meditation is an age old practice,
             first used for religious purposes.
               Today we utilize mindfulness for it's many known benifits.
               This includes improving your ability to handle stress and to be present in the moment. </Typography>
               <Typography sx={textStyle} as={Link} href='https://parade.com/969668/ericasweeney/benefits-of-meditation/' rel="noopener" target='_blank'>See 100 benifits of meditation.</Typography>
        <Typography variant='h6' sx={{pb:{xs:1,md:2},pt:{xs:2,md:4},fontSize:{xs:24,sm:32,md:40}}}>How to use Guidedly</Typography> 
        <Typography sx={textStyle}>Choose one or as many mantras or phrases as you wish. At each interval, Guidedly will will randomly select one of your phrases.
            Set you disired interval timing alomg with the length of time for your meditation and begin.
        </Typography>
        <Typography sx={{pt:2,...textStyle}}>Background gif designed by 
          <Typography sx={{...textStyle,pl:1}} as={Link} href='https://dribbble.com/shots/8586244-Meditation' rel="noopener" target='_blank'>Andrii Burak</Typography>
        </Typography>

        <Typography sx={{...textStyle}}>Original illustration by  
          <Typography sx={{...textStyle,pl:1}} as={Link} href='https://www.freepik.com/free-vector/man-meditating-with-flat-design_2488440.htm#query=monk%20meditating&position=9&from_view=keyword' rel="noopener" target='_blank'>Freepik</Typography>
        </Typography>
        <Typography color="primary.main" sx={{pt:{xs:3,md:6},...textStyle}} align='center'>Copyright © Guidedly 2022</Typography>
    </Box>
  )
}

export default Info